import { render, staticRenderFns } from "./MicroPie.vue?vue&type=template&id=54ed11c5&scoped=true&"
import script from "./MicroPie.vue?vue&type=script&lang=js&"
export * from "./MicroPie.vue?vue&type=script&lang=js&"
import style0 from "./MicroPie.vue?vue&type=style&index=0&id=54ed11c5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed11c5",
  null
  
)

export default component.exports